<template>
  <div class="student-tab-schedule">
    <md-card class="card-content">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("common.schedule") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-40 md-small-size-100">
            <md-field>
              <label class="select-label">{{ $t("common.term") }}</label>
              <md-select name="term" id="term" v-model="termId">
                <md-option
                  v-for="term in termOptions"
                  :key="term.id + term.name"
                  :value="term.id"
                >
                  {{ $t(term.name) }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div
            class="md-layout-item md-size-60 md-small-size-100 text-right"
            v-show="enabledExport"
          >
            <md-button @click.prevent="exportFile()" class="md-warning">
              {{ $t("schedule.export_file") }}
            </md-button>
          </div>
        </div>

        <div class="md-layout" v-if="enabledExport">
          <div
            class="md-layout-item md-size-100 mb-8"
            v-if="loopSchedule && loopSchedule.length"
          >
            <h3 class="text-base font-semibold mb-3">
              {{ $t("schedule.loop_schedule") }}
            </h3>
            <md-table class="md-scrollbar schedule-table">
              <md-table-row>
                <th class="diagonal-cross font-medium">
                  <span class="sup">{{ $t("common.day") }}</span>
                  <span class="sub">{{ $t("common.term") }}</span>
                  <div class="line-diagonal"></div>
                </th>
                <th class="font-medium">{{ $t("common.monday") }}</th>
                <th class="font-medium">{{ $t("common.tuesday") }}</th>
                <th class="font-medium">{{ $t("common.wednesday") }}</th>
                <th class="font-medium">{{ $t("common.thursday") }}</th>
                <th class="font-medium">{{ $t("common.friday") }}</th>
                <th class="font-medium">{{ $t("common.saturday") }}</th>
                <th class="font-medium">{{ $t("common.sunday") }}</th>
              </md-table-row>

              <md-table-row
                v-for="(schedule, index) in loopSchedule"
                :key="'schedule' + index"
              >
                <md-table-cell class="font-medium">{{
                  `${schedule.term_name} (${convertDate(
                    schedule.term_start,
                    schedule.term_end
                  )})`
                }}</md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Monday']"
                  ></cell-schedule>
                </md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Tuesday']"
                  ></cell-schedule>
                </md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Wednesday']"
                  ></cell-schedule>
                </md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Thursday']"
                  ></cell-schedule>
                </md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Friday']"
                  ></cell-schedule>
                </md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Saturday']"
                  ></cell-schedule>
                </md-table-cell>
                <md-table-cell class="content-cell">
                  <cell-schedule
                    :day="schedule.raw_data['Sunday']"
                  ></cell-schedule>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
          <div
            class="md-layout-item md-size-100 mb-8"
            v-if="irregularly && irregularly.length"
          >
            <h3 class="text-base font-semibold mb-3">
              {{ $t("schedule.irregularly_schedule") }}
            </h3>
            <md-table class="md-scrollbar schedule-table">
              <md-table-row>
                <th class="font-medium">{{ $t("common.no_number") }}</th>
                <th class="font-medium">{{ $t("term.term_name") }}</th>
                <th class="font-medium">{{ $t("class.class_name") }}</th>
                <th class="font-medium">{{ $t("schedule.class_time") }}</th>
                <th class="font-medium">{{ $t("common.description") }}</th>
              </md-table-row>

              <md-table-row
                v-for="(row, index) in irregularly"
                :key="'irregularly' + index"
              >
                <md-table-cell class="text-center">{{
                  index + 1
                }}</md-table-cell>
                <md-table-cell>{{ row.term_name }}</md-table-cell>
                <md-table-cell>{{ row.class_name }}</md-table-cell>
                <md-table-cell
                  >{{ convertDateFromServer(row.class_time, "date") }},
                  {{ row.class_time_hour }}</md-table-cell
                >
                <md-table-cell>{{ row.description }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>
          <div class="md-layout-item md-size-100" v-if="event && event.length">
            <h3 class="text-base font-semibold mb-3">
              {{ $t("schedule.related_events") }}
            </h3>
            <md-table class="md-scrollbar schedule-table">
              <md-table-row>
                <th class="font-medium px-3">{{ $t("common.no_number") }}</th>
                <th class="font-medium">{{ $t("schedule.event_name") }}</th>
                <th class="font-medium">
                  <span class="w-max inline-block px-3">{{
                    $t("schedule.event_type")
                  }}</span>
                </th>
                <th class="font-medium">
                  <span class="w-max inline-block px-3">{{
                    $t("schedule.event_time")
                  }}</span>
                </th>
                <th class="font-medium">{{ $t("schedule.location") }}</th>
                <th class="font-medium">{{ $t("common.description") }}</th>
              </md-table-row>

              <md-table-row
                v-for="(row, index) in event"
                :key="'event' + index"
              >
                <md-table-cell class="text-center">{{
                  index + 1
                }}</md-table-cell>
                <md-table-cell>{{ row.name }}</md-table-cell>
                <md-table-cell>
                  <span class="w-max inline-block">{{
                    generateEventType(row.category)
                  }}</span>
                </md-table-cell>
                <md-table-cell>{{
                  convertDate(row.start, row.end)
                }}</md-table-cell>
                <md-table-cell>{{ row.location }}</md-table-cell>
                <md-table-cell>{{ row.description }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
        <div v-else>
          <no-data-found></no-data-found>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { service_names } from "@/constants/Services";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import CellSchedule from "./CellSchedule";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { generateEventType } from "@/helpers/text-helper";
import { Message } from "../../../../../helpers/utils";

export default {
  name: "tab-schedule",
  components: { CellSchedule, NoDataFound },
  props: ["isActiveTab"],
  data() {
    return {
      studentId: this.$route.params.id,
      termId: "",
      termOptions: [],
      loopSchedule: [],
      irregularly: [],
      event: [],
      enabledExport: false,
      convertDateFromServer,
      isActive: false,
      dataExport: null,
      generateEventType
    };
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.initData();
        this.isActive = true;
      }
    },
    termId() {
      this.search();
    }
  },
  methods: {
    loadData(data) {},
    initData() {
      this.getTermOptions();
      this.search();
    },
    getTermOptions() {
      this.$axios
        .get(`${service_names.utility}/students/${this.studentId}/term`)
        .then(response => {
          this.termOptions = [...DEFAULT_OPTION_ALL, ...response.data];
        });
    },

    search() {
      this.$axios
        .get(`${service_names.utility}/students/${this.studentId}/schedule`, {
          term_id: this.termId
        })
        .then(response => {
          this.loopSchedule = response.data.loop_schedule;
          this.irregularly = response.data.irregularly;
          this.event = response.data.event;

          this.enabledExport =
            !!this.loopSchedule || !!this.irregularly || !!this.event;

          this.dataExport = response.data;
        });
    },

    convertDate(startDate, endDate) {
      return `${convertDateFromServer(startDate, "date")} ${this.$t(
        "common.to"
      )} ${convertDateFromServer(endDate, "date")}`;
    },

    exportFile() {
      const path = `${service_names.utility}/students/${this.studentId}/schedule/export-pdf`;
      this.$axios
        .get(path, { term_id: this.termId }, true, {}, "blob")
        .then(response => {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "schedule.pdf");
            document.body.appendChild(link);
            link.click();
            Message.success(this.$t("common.export_success"));
            link.remove();
          } else {
            Message.error(this.$t("common.an_error_occurred"));
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.select-label {
  top: unset;
  bottom: 36px !important;
  font-size: 14px;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #3c4858;
  }

  td {
    padding: 8px;
    vertical-align: top;
  }

  .diagonal-cross {
    position: relative;
    height: 50px;
    width: 150px !important;
    min-width: 150px;
  }

  .line-diagonal {
    position: absolute;
    top: 49%;
    left: -7px;
    width: 160px;
    border-top: 1px solid #3c4858;
    transform: rotate(18deg);
  }

  .sup {
    position: absolute;
    top: 0;
    right: 10px;
  }

  .sub {
    position: absolute;
    bottom: 0;
    left: 10px;
  }

  .content-cell .content-cell-item {
    border-top: 1px solid #d2d2d2;
    padding: 5px 0;
    color: rgba(0, 0, 0, 0.6);

    & .font-medium {
      color: rgba(60, 72, 88, 1);
    }
  }

  .content-cell-item:first-child {
    border-top: none;
  }
}
</style>
